import { ELEMENT_IDS, pipStyles } from "./pipStyles";
import { addRecordLabel, createStyledElement } from "./pipWindow";

const blueRevertSvg = require("../../../../../images/svg/blue-revert-icon.svg");

const MAX_RECORDING_TIME = 300;
const FORMATTED_MAX_RECORDING_TIME = `${MAX_RECORDING_TIME / 60}:00`;

let recordingTimer: number | null = null;
let elapsedSeconds = 0;


const updateTimeLabel = (pipWindow: Window, time: number) => {
    if (!pipWindow) {
        return;
    }

    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

    const recordLabel = pipWindow.document.getElementById(ELEMENT_IDS.RECORD_LABEL);

    if (recordLabel) {
        recordLabel.innerText = `${formattedMinutes}:${formattedSeconds} / ${FORMATTED_MAX_RECORDING_TIME}`;
    }
};

export const removeTimeLimitScreen = (pipWindow: Window) => {
    pipWindow.document.getElementById(ELEMENT_IDS.TIME_LIMIT_SCREEN)?.remove();
};

const addTimeLimitScreen = (
    pipWindow: Window,
    onSaveHandler: () => void,
    onRetakeHandler: () => void
) => {
    if (!pipWindow) {
        return;
    }

    const screenWrapper = createStyledElement("div", pipStyles.timesUpScreenWrapper);
    screenWrapper.id = ELEMENT_IDS.TIME_LIMIT_SCREEN;

    const container = createStyledElement("div", pipStyles.timesUpContainer);

    const label = createStyledElement("label", pipStyles.recordLabel);
    label.innerText = "Recording stopped. \n The 5 minute time limit was exceeded.";
    label.style.textAlign = "center";

    const saveButton = createStyledElement("button", pipStyles.saveButton);
    saveButton.innerText = "Save";
    saveButton.onclick = onSaveHandler;

    const reRecordButton = createStyledElement("button", pipStyles.reRecordButton);
    reRecordButton.onclick = onRetakeHandler;

    const revertIcon = document.createElement("img") as HTMLImageElement;
    revertIcon.src = blueRevertSvg;
    revertIcon.alt = "revertSvg";
    revertIcon.style.width = "13px";
    revertIcon.style.height = "13px";
    revertIcon.style.marginRight = "8px"; // Adds spacing between icon and label

    reRecordButton.append(revertIcon, "Re-record");

    container.appendChild(label);
    container.appendChild(saveButton);
    container.appendChild(reRecordButton);

    screenWrapper.append(container);
    pipWindow.document.body.append(screenWrapper);
};

/**
 * The shared per-second tick logic.
 */
function spawnRecordingInterval(
    pipWindow: Window,
    onSave: () => void,
    onRetake: () => void
): number {
    return window.setInterval(() => {
        elapsedSeconds += 1;

        if (elapsedSeconds <= MAX_RECORDING_TIME) {
            updateTimeLabel(pipWindow, elapsedSeconds);
        }

        if (elapsedSeconds === MAX_RECORDING_TIME) {
            clearInterval(recordingTimer!);
            recordingTimer = null;
            addTimeLimitScreen(pipWindow, onSave, onRetake);
        }
    }, 1000);
}

/**
 * Starts ticking the recording clock in the PiP UI.
 */
/** now takes your callbacks */
export function startRecordingTimer(
    pipWindow: Window,
    onSave: () => void,
    onRetake: () => void
) {
    elapsedSeconds = 0;
    updateTimeLabel(pipWindow, elapsedSeconds);

    if (recordingTimer != null) {
        clearInterval(recordingTimer);
    }
    recordingTimer = spawnRecordingInterval(pipWindow, onSave, onRetake);
}

/**
 * Pauses the recording clock but keeps the elapsed time.
 */
export function pauseRecordingTimer() {
    if (recordingTimer != null) {
        clearInterval(recordingTimer);
        recordingTimer = null;
    }
}

/**
 * Resumes the recording clock from wherever it was paused.
 */
export function resumeRecordingTimer(
    pipWindow: Window,
    onSave: () => void,
    onRetake: () => void
) {
    if (recordingTimer != null) {
        return;
    }

    updateTimeLabel(pipWindow, elapsedSeconds);

    recordingTimer = spawnRecordingInterval(pipWindow, onSave, onRetake);
}

/**
 * Stops and clears the recording clock.
 */
export function stopRecordingTimer(pipWindow: Window) {
    pauseRecordingTimer();
    addRecordLabel(pipWindow);
}
